import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { PhysicalAccessControlModels } from '@models/physical-access-control.models';

@Injectable({
  providedIn: 'root',
})
export class PhysicalAccessControlService {
  constructor(private http: HttpClient) {}

  public getAll(
    filters: PhysicalAccessControlModels.GetPhysicalAccessControlRequestFilters,
  ): Observable<PhysicalAccessControlModels.PhysicalAccessControlDocument[]> {
    let url = `${api.physicalAccessControl.crud}?`;
    if (filters.locationId) {
      url += `locationId=${filters.locationId}`;
    }
    if (filters.query) {
      url += `&query=${encodeURIComponent(filters.query)}`;
    }
    return this.http.get<PhysicalAccessControlModels.PhysicalAccessControlDocument[]>(url);
  }

  public create(data: PhysicalAccessControlModels.CreatePhysicalAccessControlRequest): Observable<any> {
    return this.http.post<any>(api.physicalAccessControl.crud, data);
  }

  public save(data: PhysicalAccessControlModels.SavePhysicalAccessControlRequest): Observable<any> {
    return this.http.put<any>(api.physicalAccessControl.one(data._id), data);
  }

  public testConnection(data: PhysicalAccessControlModels.TestPhysicalAccessControlRequest): Observable<any> {
    return this.http.post<any>(api.physicalAccessControl.test, data);
  }

  public delete(locationId: string, id: string): Observable<any> {
    return this.http.delete<any>(api.physicalAccessControl.delete(locationId, id));
  }

  public getOne(id: string): Observable<PhysicalAccessControlModels.PhysicalAccessControlDocument> {
    return this.http.get<PhysicalAccessControlModels.PhysicalAccessControlDocument>(api.physicalAccessControl.one(id));
  }
}


